import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import { reportClick } from './itemsActions'


const ItemLink = ({ item, dispatch, gaItemClickUiElement }) => {

  const handleLinkOpened = (e) => {
    if (e.button === 2) return // ignore right-click (context menu, not a navigation)
    dispatch(reportClick(item, gaItemClickUiElement))
  }

  return (
    <a
      href={ item.get('link') }
      target='_blank'
      rel='noopener'
      onClick={ handleLinkOpened }
      onAuxClick={ handleLinkOpened }
    >
      { item.get('title') }
    </a>
  )
}

ItemLink.propTypes = exact({
  item: ImmutablePropTypes.map.isRequired,
  dispatch: PropTypes.func.isRequired,
  gaItemClickUiElement: PropTypes.string.isRequired,
})

export default ItemLink
